import { PropsWithChildren } from 'react';

import { Card, Divider } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

type PlanItemCardProps = PropsWithChildren<{
  disabled?: boolean;
  sectionName?: string;
}>;

const PlanItemCard: React.FC<PlanItemCardProps> = ({
  sectionName,
  children,
  disabled,
}) => (
  <Card className={cn('mb-6! p-4! text-left!', disabled && 'no-hover')}>
    {sectionName && (
      <>
        <div className="flex w-full">
          <p
            data-testid={`Title-${sectionName}`}
            className="text-grayscale-gray6 text-variant-body1 line-clamp-1 w-full overflow-hidden font-bold wrap-break-word"
          >
            {sectionName}
          </p>
        </div>
        <Divider variant="fullLength" className="my-4!" />
      </>
    )}
    <div className="flex w-full flex-col gap-5 overflow-hidden">{children}</div>
  </Card>
);

export default PlanItemCard;
